exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2r31E9CwXSy4FI{background-color:#fafcfc;border-radius:3px;height:20px;width:20px}._2r31E9CwXSy4FI,._2VaC6eKdpfQeHj{box-shadow:inset 0 0 0 2px #dfe3e6}._2VaC6eKdpfQeHj{background-color:#f5f6f7}._27OdAGgFTfVH9T{background-color:#ebeef0;box-shadow:inset 0 0 0 2px #dfe3e6}.V8NCIUE34WcUG7{background-color:#17394d;box-shadow:inset 0 0 0 2px #17394d}._2clIrap4nUBj_X{background-color:#fff;box-shadow:none}._2SFuvR9tW1Tc0I{background-color:#ebeef0;box-shadow:none}._3va7mbXZWHpUnl{background-color:#c2ccd1;box-shadow:none}._2HQkWOWjqZviZ1,._30aZcWZ9bvGjGO{border-radius:3px;border:0;cursor:pointer;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;text-decoration:none}._30aZcWZ9bvGjGO{font-family:trellicons}._1xxg05ahKLbkN9{border-radius:3px;border:0;cursor:pointer;text-decoration:none;background-image:none;box-shadow:none;color:#6b808c;display:block;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:14px;font-weight:400;padding:0;text-align:left;width:100%}._1xxg05ahKLbkN9:active,._1xxg05ahKLbkN9:hover{background:transparent;box-shadow:none}.WgGcL9SgAyMIir{line-height:22px;margin:8px 4px 0 0;padding:5px 16px;box-shadow:0 1px 0 #3f6f21;font-weight:700;text-align:center}._3RHIFaa05OXxal{padding:0;text-decoration:none;text-shadow:none}._3RHIFaa05OXxal,._3RHIFaa05OXxal:hover{background:transparent;border-color:transparent;box-shadow:none}._3RHIFaa05OXxal:hover{text-decoration:underline}._3iJVcfXURHhrGS{border-radius:3px;border:0;cursor:pointer;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;text-decoration:none;line-height:22px;margin:8px 4px 0 0;padding:5px 16px;box-shadow:0 1px 0 #3f6f21;font-weight:700;text-align:center;background:linear-gradient(180deg,#fff 0,#f8f9f9);box-sizing:border-box;border:1px solid #e2e4e6;border-bottom-color:#cdd2d4;box-shadow:none;max-width:300px;overflow:hidden;position:relative;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3iJVcfXURHhrGS ._3gkcuKop5TXDYm{margin:0 5px 0 -10px}._3iJVcfXURHhrGS:hover{background:#298fca;border-color:#298fca #298fca #026aa7;color:#fff}._11YZYgcy2XNm7a{border-radius:3px;border:0;cursor:pointer;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;text-decoration:none;line-height:22px;margin:8px 4px 0 0;padding:5px 16px;box-shadow:0 1px 0 #3f6f21;font-weight:700;text-align:center;background:linear-gradient(180deg,#cdd2d4 0,#b6bbbf)}._11YZYgcy2XNm7a:hover{background:linear-gradient(180deg,#c4c9cc 0,#a5acb0)}._11YZYgcy2XNm7a:focus{background:linear-gradient(180deg,#b6bbbf 0,#959da1)}.GO50314hSKKDDz{border-radius:3px;border:0;cursor:pointer;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;text-decoration:none;line-height:22px;margin:8px 4px 0 0;padding:5px 16px;box-shadow:0 1px 0 #3f6f21;font-weight:700;text-align:center;background-color:#5aac44;border:none}.GO50314hSKKDDz,.GO50314hSKKDDz:hover{box-shadow:0 1px 0 0 #3f6f21;color:#fff}.GO50314hSKKDDz:hover{background-color:#519839;border:none}.GO50314hSKKDDz:active{background-color:#49852e;box-shadow:0 1px 0 0 #3f6f21;border:none;color:#fff}.GO50314hSKKDDz:disabled{background-color:#ebeef0;box-shadow:none;border:none;color:#a6b3ba;cursor:not-allowed}._1BxvSQhD_aAKUN{border-radius:3px;border:0;cursor:pointer;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;text-decoration:none;line-height:22px;margin:8px 4px 0 0;padding:5px 16px;box-shadow:0 1px 0 #3f6f21;font-weight:700;text-align:center;background-color:#cf513d;box-shadow:0 1px 0 0 #6e2f1a;border:none;color:#fff}._1BxvSQhD_aAKUN:hover{background-color:#b04632}._1BxvSQhD_aAKUN:active,._1BxvSQhD_aAKUN:hover{box-shadow:0 1px 0 0 #6e2f1a;border:none;color:#fff}._1BxvSQhD_aAKUN:active{background-color:#933b27}._1OlWF8scX_DffK{background-image:none;background-color:#eb5a46;border-color:#eb5a46;border-bottom-color:#b04632;box-shadow:none;color:#fff;font-weight:700;transition:background-color .3s ease}._1OlWF8scX_DffK:focus,._1OlWF8scX_DffK:hover{background-image:none;background-color:#cf513d;border-color:#cf513d;border-bottom-color:#933b27}._1OlWF8scX_DffK:active{background-image:none;background-color:#933b27;border-color:#933b27;border-bottom-color:transparent}._2W39xs0FnDdi0h{padding-left:30px;padding-right:30px}._1z76-dFiZ8iCL_{background:#e2e4e6;box-shadow:0 1px 0 0 #c4c9cc;border-radius:3px;box-sizing:border-box;cursor:pointer;display:block;font-weight:700;height:32px;margin-top:8px;max-width:300px;overflow:hidden;padding:6px 8px 6px 11px;position:relative;text-decoration:none;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"N0": "#FFFFFF",
	"N10": "#FAFCFC",
	"N20": "#F5F6F7",
	"N30": "#EBEEF0",
	"N40": "#DFE3E6",
	"N50": "#C2CCD1",
	"N60": "#B3BEC4",
	"N70": "#A6B3BA",
	"N80": "#97A7B0",
	"N90": "#899AA3",
	"N100": "#798D99",
	"N200": "#6B808C",
	"N300": "#5E7785",
	"N400": "#516B7A",
	"N500": "#425E6E",
	"N600": "#355263",
	"N700": "#254659",
	"N800": "#17394D",
	"N900": "#092D42",
	"N10A": "rgba(9, 45, 66, 0.02)",
	"N20A": "rgba(9, 45, 66, 0.04)",
	"N30A": "rgba(9, 45, 66, 0.08)",
	"N40A": "rgba(9, 45, 66, 0.13)",
	"N50A": "rgba(9, 45, 66, 0.25)",
	"N60A": "rgba(9, 45, 66, 0.31)",
	"N70A": "rgba(9, 45, 66, 0.36)",
	"N80A": "rgba(9, 45, 66, 0.42)",
	"N90A": "rgba(9, 45, 66, 0.48)",
	"N100A": "rgba(9, 45, 66, 0.54)",
	"N200A": "rgba(9, 45, 66, 0.6)",
	"N300A": "rgba(9, 45, 66, 0.66)",
	"N400A": "rgba(9, 45, 66, 0.71)",
	"N500A": "rgba(9, 45, 66, 0.77)",
	"N600A": "rgba(9, 45, 66, 0.82)",
	"N700A": "rgba(9, 45, 66, 0.89)",
	"N800A": "rgba(9, 45, 66, 0.95)",
	"trello-blue-50": "#E4F0F6",
	"trello-blue-100": "#BCD9EA",
	"trello-blue-200": "#8BBDD9",
	"trello-blue-300": "#5BA4CF",
	"trello-blue-400": "#298FCA",
	"trello-blue-500": "#0079BF",
	"trello-blue-600": "#026AA7",
	"trello-blue-700": "#055A8C",
	"trello-blue-800": "#094C72",
	"trello-blue-900": "#0C3953",
	"green-50": "#EEF6EC",
	"green-100": "#D6ECD2",
	"green-200": "#B7DDB0",
	"green-300": "#99D18F",
	"green-400": "#7BC86C",
	"green-500": "#61BD4F",
	"green-600": "#5AAC44",
	"green-700": "#519839",
	"green-800": "#49852E",
	"green-900": "#3F6F21",
	"orange-50": "#FDF4E7",
	"orange-100": "#FCE6C6",
	"orange-200": "#FAD29C",
	"orange-300": "#FDBF69",
	"orange-400": "#FFAF3F",
	"orange-500": "#FF9F1A",
	"orange-600": "#E79217",
	"orange-700": "#CD8313",
	"orange-800": "#B4760F",
	"orange-900": "#96650A",
	"red-50": "#FBEDEB",
	"red-100": "#F5D3CE",
	"red-200": "#EFB3AB",
	"red-300": "#EC9488",
	"red-400": "#EF7564",
	"red-500": "#EB5A46",
	"red-600": "#CF513D",
	"red-700": "#B04632",
	"red-800": "#933B27",
	"red-900": "#6E2F1A",
	"yellow-50": "#FDFAE5",
	"yellow-100": "#FAF3C0",
	"yellow-200": "#F5EA92",
	"yellow-300": "#F3E260",
	"yellow-400": "#F5DD29",
	"yellow-500": "#F2D600",
	"yellow-600": "#E6C60D",
	"yellow-700": "#D9B51C",
	"yellow-800": "#CCA42B",
	"yellow-900": "#BD903C",
	"purple-50": "#F7F0FA",
	"purple-100": "#EDDBF4",
	"purple-200": "#DFC0EB",
	"purple-300": "#D5A6E6",
	"purple-400": "#CD8DE5",
	"purple-500": "#C377E0",
	"purple-600": "#A86CC1",
	"purple-700": "#89609E",
	"purple-800": "#6C547B",
	"purple-900": "#484553",
	"pink-50": "#FEF1F9",
	"pink-100": "#FCDCEF",
	"pink-200": "#F9C2E4",
	"pink-300": "#FFABDF",
	"pink-400": "#FF8ED4",
	"pink-500": "#FF78CB",
	"pink-600": "#E568AF",
	"pink-700": "#C9558F",
	"pink-800": "#AE4270",
	"pink-900": "#8E2D4B",
	"sky-50": "#E4F7FA",
	"sky-100": "#BDECF3",
	"sky-200": "#8FDFEB",
	"sky-300": "#5DD3E5",
	"sky-400": "#29CCE5",
	"sky-500": "#00C2E0",
	"sky-600": "#00AECC",
	"sky-700": "#0098B7",
	"sky-800": "#0082A0",
	"sky-900": "#006988",
	"lime-50": "#ECFBF3",
	"lime-100": "#D3F6E4",
	"lime-200": "#B3F1D0",
	"lime-300": "#90ECC1",
	"lime-400": "#6DECA9",
	"lime-500": "#51E898",
	"lime-600": "#4ED583",
	"lime-700": "#4BBF6B",
	"lime-800": "#49AA54",
	"lime-900": "#459139",
	"business-blue-50": "#EDEFF4",
	"business-blue-100": "#D2D7E5",
	"business-blue-200": "#B2B9D0",
	"business-blue-300": "#838FB5",
	"business-blue-400": "#6170A1",
	"business-blue-500": "#42548E",
	"business-blue-600": "#3E4D80",
	"business-blue-700": "#3A476F",
	"business-blue-900": "#30364C",
	"business-blue-800": "#36405F",
	"blue-500": "#0079BF",
	"black": "#000",
	"black-500": "#4d4d4d",
	"near-black": "#4d4d4d",
	"white": "#FFFFFF",
	"m-badge-toggle-default": "_2r31E9CwXSy4FI",
	"m-badge-toggle-off-idle": "_2VaC6eKdpfQeHj",
	"m-badge-toggle-off-hover": "_27OdAGgFTfVH9T",
	"m-badge-toggle-off-active": "V8NCIUE34WcUG7",
	"m-badge-toggle-on-idle": "_2clIrap4nUBj_X",
	"m-badge-toggle-on-hover": "_2SFuvR9tW1Tc0I",
	"m-badge-toggle-on-active": "_3va7mbXZWHpUnl",
	"button": "_2HQkWOWjqZviZ1",
	"iconButton": "_30aZcWZ9bvGjGO",
	"textButton": "_1xxg05ahKLbkN9",
	"bigButton": "WgGcL9SgAyMIir",
	"buttonLink": "_3RHIFaa05OXxal",
	"linkButton": "_3iJVcfXURHhrGS",
	"icon": "_3gkcuKop5TXDYm",
	"buttonSecondary": "_11YZYgcy2XNm7a",
	"buttonPrimary": "GO50314hSKKDDz",
	"buttonNegate": "_1BxvSQhD_aAKUN",
	"buttonRed": "_1OlWF8scX_DffK",
	"wide": "_2W39xs0FnDdi0h",
	"blockButton": "_1z76-dFiZ8iCL_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2936/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/shared/button.less
// module id = 80mB
// module chunks = 13